import { createClient as createUrqlClient } from "@urql/core";
import { GRAPHQL_ENDPOINTS } from "../constants";
import { selectValueByApiEnv, getCorrelationId } from "../utils";
/**
 * Create a GQL request client with appropriate headers.
 *
 * @public
 */ const getClient = ({ authToken, environment, name })=>{
    /**
   * This is a closure so that correlation ID is re-evaluated for each request.
   */ const fetchOptions = ()=>({
            headers: {
                Authorization: authToken ? `Bearer ${authToken}` : '',
                'apollographql-client-name': name,
                'x-mgm-channel': 'web',
                'x-mgm-correlation-id': getCorrelationId(),
                'x-mgm-source': 'mgmri'
            }
        });
    return createUrqlClient({
        fetchOptions,
        url: selectValueByApiEnv(environment, {
            ...GRAPHQL_ENDPOINTS,
            fallback: GRAPHQL_ENDPOINTS.PROD
        })
    });
};
export default getClient;
